(function () {
  function initSec(sec) {
    if (!sec || sec.dataset.kzvInit) return;
    sec.dataset.kzvInit = '1';
    var sc = sec.querySelector('[data-kzv-scroll]');
    var dots = sec.querySelectorAll('[data-kzv-dot]');
    if (!sc || dots.length < 2) return;
    function step() {
      var c = sc.querySelector('.kzv__card');
      return c ? c.getBoundingClientRect().width + 12 : sc.clientWidth;
    }
    function upd() {
      var i = Math.round(sc.scrollLeft / step());
      i = Math.max(0, Math.min(dots.length - 1, i));
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }
    sc.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
    dots.forEach(function (d, n) {
      d.addEventListener('click', function () { sc.scrollTo({ left: n * step(), behavior: 'smooth' }); });
    });
    upd();
  }
  function boot() { document.querySelectorAll('[data-kzv]').forEach(initSec); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
